import { render, staticRenderFns } from "./ButtonMultiple.vue?vue&type=template&id=cfcffb52&"
import script from "./ButtonMultiple.vue?vue&type=script&lang=js&"
export * from "./ButtonMultiple.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMultiple.vue?vue&type=style&index=0&id=cfcffb52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports